export default __webpack_public_path__ + "static/zynga-office-574d78167a279f1f74b6a13d751d559c.jpg";